import { useCallback } from "react";
import type { NestDocumentTypes, NestUseCase } from "src/api/interfaces/nest";

const STORAGE_KEY_PREFIX = "nest:docType:";

export function useDocumentTypePreference() {
  const getDocumentType = useCallback(
    (useCase: NestUseCase): NestDocumentTypes => {
      const stored = localStorage.getItem(STORAGE_KEY_PREFIX + useCase.id);
      const found = stored
        ? useCase.documentTypes.find((dt) => dt.id === stored)
        : undefined;
      return found ?? useCase.documentTypes[0];
    },
    []
  );

  const setDocumentType = useCallback(
    (useCaseId: string, documentTypeId: string) => {
      localStorage.setItem(STORAGE_KEY_PREFIX + useCaseId, documentTypeId);
    },
    []
  );

  return { getDocumentType, setDocumentType };
}
